import {serverRoot} from "framework/api";
import {ApplicationState} from "framework/applicationState";

export function getFileByStreamId(id: string): any {
	window.open(`${serverRoot}sessions/${ApplicationState.apiToken}/downloadFile/${id}`);
}
